module.exports = __webpack_public_path__ + "img/clos-menu.e778301d.svg";